
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel/zones/[slug]/surf-guide/[spot]/[id]",
      function () {
        return require("private-next-pages/travel/zones/[slug]/surf-guide/[spot]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel/zones/[slug]/surf-guide/[spot]/[id]"])
      });
    }
  